
import {DespieceContainer} from "./style"

const Despiece = ({content}) => {
    const {title, html} =content.value
    return (
    <DespieceContainer>
        <p className="DespieceTitle">{title}</p>
        <div  suppressHydrationWarning dangerouslySetInnerHTML={{ __html: content.value.html }} /> 
     </DespieceContainer>
    )
}

export default Despiece